import { createFileRoute, Navigate } from "@tanstack/react-router";

import React from "react";
import { UserMeProvider } from "src/context/user-me";

export const Route = createFileRoute("/")({
    /**
     * Wrapper around the index route to forward to the correct sub-path
     *
     * @returns The rendered component
     */
    component: () => (
        <UserMeProvider>
            <Navigate to={"/u/dashboard"} />
        </UserMeProvider>
    ),
});
